export default {
  packsreceipts: {
    title: "Пачки",
    info: {
      modal: {
        title: {
          vagueReadings: "Квитанции с неопределенными показаниями",
          deletedPacksPeriodWith: "Удаленные разнесенные пачки за период с",
          deletedPacksPeriodBy: "по"
        }
      }
    },
    editForm: {
      modal: {
        title: {
          packageInfo: "Информация о пачке",
          compensationVisually: "Компенсация инвалидам по зрению",
          socialSupplementInfo: "Информация о социальной доплате",
          grantInfo: "Информация о субсидии"
        }
      },
      form: {
        packnumber: "Банковский номер пачки",
        datebank: "Дата по банку",
        codefirme: "Плательщик",
        accountSender: "Р/счет плательщика",
        kindpay: "Способ оплаты",
        summa: "Сумма",
        sumprof: "За услуги",
        userid: "Оператор",
        quantity: {
          numberSubscribers: "Кол-во абонентов",
          numberReceipts: "Кол-во квитанций"
        },
        countband: {
          numberSheets: "Кол-во листов",
          numberCountband: "Кол-во бандеролей"
        },
        addPayment: "Занести сразу квитанцию по этой пачке?"
      }
    },
    uploadForm: {
      modal: {
        title: "Загрузка файлов"
      },
      form: {
        uploadfile: "Файлы для загрузки"
      }
    },
    import: {
      modal: {
        title: {
          payments: "Импорт платежей",
          subsidies: "Импорт субсидий"
        }
      },
      form: {
        codeimport: "Тип входных данных",
        kindpay: "Способ оплаты",
        codepayRadio: {
          title: "Назначение платежа",
          file: "Брать из файла",
          customer: "Установить свое"
        },
        fileinfo: "Информация о файле"
      },
      result: {
        success: "Успешно",
        error: "Ошибка"
      }
    },
    confirmDateBank: {
      modal: {
        title: "Проверка даты по банку"
      },
      form: {
        description:
          "Проверьте правильность даты по банку, указанной в импортируемой пачке",
        dateBank: "Дата по банку"
      },
      importError: "Не завершена проверка даты по банку"
    },
    confirmSender: {
      modal: {
        title: "Организация-отправитель"
      },
      form: {
        orgSendPack: "Укажите организацию, отправившую пачку",
        rcount: "р/счет"
      }
    },
    confirmSenderMfo: {
      modal: {
        title: "Организация-отправитель"
      },
      form: {
        mfo: "МФО",
        orgSendPack: "Укажите организацию, отправившую пачку",
        rcount: "р/счет"
      }
    },
    confirmDestLink: {
      modal: {
        title: "Описание связи назначения",
        description:
          "Укажите какое из назначений платежей соответствует платежу с названием:",
        code: "код",
        additionallyImport: "Дополнительно при импорте такого платежа",
        additionallyMeterReading:
          "заносить показания счетчика, если они указаны"
      },
      importError: "Ошибка при импорте! Не указано назначение платежа."
    },
    confirmSenderMfoNumber: {
      modal: {
        title: "Организация-отправитель",
        description: "Укажите организацию, отправившую пачку",
        mfo: "МФО",
        number: "Номер"
      },
      importError:
        "Ошибка при импорте! Не указана организация, отправившая пачку."
    },
    statusModify: {
      add: "Добавление",
      edit: "Изменение",
      delete: "Сторнирование"
    },
    confirmImport: {
      title: "Импорт"
    },
    importFiles: {
      error: "Нарушение структуры реестра в файле",
      sender: "Отправитель",
      datapack: "Дата",
      countpack: "Кол-во",
      summapack: "Сумма",
      kompack: "Комиссионные",
      denyChangeListFiles: "Изменение списка файлов после импорта невозможно",
      importedFiles: "Импортировано файлов: {files}",
      noAvailableImportFiles: "Нет доступных для импорта файлов",
      alert: {
        message: "Импорт пачек завершён",
        title: "Импорт"
      }
    },
    postingBtn: {
      confirm: {
        postingPack: "Разнести пачку",
        summaPack: "на сумму",
        senderPack: "отправитель",
        title: "Разноска"
      }
    }
  }
};
